import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import MovieList from "./MovieList";
import MenuCustomAnimation from "./MenuCustomAnimation";
import { useSelector } from "react-redux";
import { movieGenres } from "../utils/movieGeneres";

const MyList = () => {
	const [movieGenreId, setmovieGenreId] = useState(null);
	const myListMovies = useSelector((store) => store.movies.wishlist) || [];

	const genreFilteredMovies = myListMovies.filter((movie) =>
		movie.genre_ids.includes(movieGenreId)
	);

	const showMovies =
		genreFilteredMovies.length > 0 ? genreFilteredMovies : myListMovies;

	return (
		<div className="my-list flex flex-col min-h-screen overflow-hidden justify-between">
			<div>
				<Header />
				<div className="mt-8 px-4 md:px-8">
					<div className="flex items-center justify-between">
						<h2 className="text-2xl text-white">My List</h2>
						{showMovies.length > 0 && (
							<div>
								<MenuCustomAnimation
									genreName={movieGenres[movieGenreId]}
									setmovieGenreId={setmovieGenreId}
								/>
							</div>
						)}
					</div>
					{showMovies.length > 0 ? (
						<MovieList movies={showMovies} />
					) : (
						<div>
							<h1 className="text-lg 2xl:text-2xl text-gray-400 pt-4 md:inline-block">
								You haven't added any movies to your list
							</h1>
							<a
								className="2xl:text-2xl md:pl-1 text-gray-400 underline hover:text-gray-200"
								href="/browse"
							>
								Browse Movies
							</a>
						</div>
					)}
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default MyList;
